/**
 * 🟥 CUADRO NEGRO API Insights v5 (feb-2026) — Narrativa + RAG fetch.
 */
const BASE = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

export async function fetchInsightsV5(userId) {
  const res = await fetch(
    `${BASE}/api/insights/v5/narrative?user_id=${encodeURIComponent(userId)}`,
    { credentials: 'include' },
  );
  return res.json();
}
